module.exports.default = {
    "ORDER": "Tilaus",
    "SCHEDULE.YOU_ARE_ALL_SET": "Kaikki on valmista",
    "SCHEDULE.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Ajanvarauksesi on asetettu päivälle",
    "SCHEDULE.CUSTOMER_#_MESSAGE": "Hei #. Varaa aikasi:",
    "SCHEDULE.SCHEDULE_NOW": "Muuta aikataulua",
    "SCHEDULE.DELIVERY_STATUS_UPDATES": "Tilauksen päivitykset",
    "SCHEDULE.EMAIL_UPDATES": "Sähköposti-ilmoitukset",
    "SCHEDULE.SMS_UPDATES": "SMS-päivitykset",
    "SCHEDULE.DISABLE_UPDATES": "En halua vastaanottaa päivityksiä",
    "SCHEDULE.STATUS_UPDATE_IN_THE_FOLLOWING": "Haluan vastaanottaa tilapäivityksiä toimituksestani seuraavien kanavien kautta:",
    "OOPS": "Hups!",
    "SOMETHING_WENT_WRONG": "Jokin meni vikaan",
    "REFRESH": "Pyydä päivitystä",
    "PAGE_NOT_FOUND": "Sivua ei löytynyt",
    "COULD_NOT_FIND_PAGE": "Emme löytäneet etsimääsi sivua.",
    "TRACKING.MESSAGE_DRIVER_FAILED": "Ei voi lähettää tyhjää viestiä",
    "TRACKING.MESSAGE_DRIVER_PLACEHOLDER": "Kirjoita viestisi kuljettajalle",
    "TRACKING.SEND": "Lähtä messengerillä",
    "TRACKING.ARRIVING_AT": "Saapuu kohteeseen",
    "TRACKING.ETA": "ETA",
    "TRACKING.MIN": "min",
    "TRACKING.MAP": "Liikenne",
    "TRACKING.SATELLITE": "Sateliitti",
    "TRACKING.TERRAIN": "Maasto",
    "TRACKING.DRIVER_ARRIVED_MESSAGE": "Hei, olen saapunut!",
    "TRACKING.DRIVER_ARRIVED_AT_MESSAGE": "on saapunut",
    "COMPLETED": "Sinulla ei ole voimassaolevia toimituksia",
    "RATING.SKIP": "Ohita",
    "RATING.WHAT_WENT_WELL": "Mikä meni hyvin?",
    "RATING.WHAT_WENT_WRONG": "Missä meillä on parannettavaa?",
    "RATING.THANK_YOU": "Kiitos",
    "RATING.FOR_USING_OUR_SERVICE": "Kiitos tilauksestasi!",
    "RATING.HOW_WAS_YOUR_DELIVERY": "How was your delivery experience?",
    "RATING.WHAT_WAS_YOUR_EXPERIENCE": "Kehittääksemme palveluamme, olisimme kiitollisia arvioinnistasi",
    "SCHEDULE.RATE_US": "Anna arviosi toiminnastamme!",
    "TERM_OF_USE": "Käyttöehdot",
    "PRIVACY_POLICY": "Tietosuoja",
    "SHARING_MY_LOCATION": "Löydä minut",
    "SHARING_LOADING": "Lataa",
    "REQUIRED_FIELD_MESSAGE": "Täytä kaikki kentät",
    "CONTACT_NAME": "Yhteyshenkilö",
    "PHONE_NUMBER": "Puhelinnumero",
    "EMAIL_ADDRESS": "Sähköpostiosoite",
    "SEND": "Lähetä",
    "FORWARD.THIS_ORDER": "Välitä tämä toimitus",
    "FORWARD.TO_CONTACT": "Välitä ….",
    "FORWARD.ARE_YOU_SURE_MESSAGE": "Haluatko varmasti lähettää tilauksen?",
    "FORWARDED.HAS_DELIVERY_FORWARDED_DELIVERY": "on välittänyt toimituksen sinulle",
    "FORWARDED.ARE_YOU_SURE_MESSAGE": "Haluatko varmasti hylätä toimituksen?",
    "ACCEPT": "Hyväksy",
    "REJECT": "Hylkää",
    "PICKUP.SET_PICKUP_TIME": "Olen matkalla",
    "PICKUP.IVE_ARRIVED": "Olen saapunut",
    "PICKUP.PICKUP_ETA_SET_FAILED": "Hups, jotain meni pieleen.\n",
    "PICKUP.ETA_SET_FAILED_DESCRIPTION": "Yritä uudelleen.",
    "PICKUP.MIN": "min",
    "PICKUP.SHOW_THIS_NUMBER": "Näytä tämä numero virkailijalle tilauksen noutamista varten",
    "PICKUP.IM_OUTSIDE": "Olen täällä",
    "PICKUP.LET_THEM_KNOW_YOUR_OUTSIDE?": "Kerro meille, kun olet täällä.",
    "PICKUP.I_WILL_ARRIVE_AT": "Saavun klo",
    "PICKUP.PICKUP_ETA_SUCCESSFULLY_SET": "Noutoaika asetettu onnistuneesti",
    "PICKUP.IN": "Sisään",
    "PICKUP.TO": "Kohteeseen",
    "PICKUP.COLLECT": "Tilaus noudettu",
    "PICKUP.SELECT_METHOD_OF_TRANSPORT": "Valitse kuljetustapa",
    "PICKUP.CONFIRM_METHOD_OF_TRANSPORT": "Vahvista kuljetustapa",
    "PICKUP.CANCEL": "Peruuta",
    "PICKUP.CONFIRM_TIME": "Vahvista noudon saapumisaika",
    "TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE": "Kuljettaja on tällä hetkellä yhden pysähdyksen päässä sinusta",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2": "asiakasta.",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1": "Ennen toimitustasi on vielä",
    "PICKUP.OK": "OK",
    "PICKUP.NEXT": "Seuraava",
    "PICKUP.SKIP": "Ohita",
    "CAR_ARRIVED.TITLE": "Viimeinen vaihe! Kerro meille, miten löydämme sinut:",
    "CAR_ARRIVED.PARKING_SPOT": "Pysäköintialue / paikan numero",
    "CAR_ARRIVED.LICENSE_PLATE": "Rekisterikilpi",
    "CAR_ARRIVED.VEHICLE_MODEL": "Ajoneuvon malli ja merkki",
    "CAR_ARRIVED.VEHICLE_COLOR": "Ajoneuvon väri",
    "CAR_ARRIVED.REMEMBER": "Muista ajoneuvoni tiedot",
    "CAR_ARRIVED.PARKING_SPOT_EXAMPLE": "(Esim: C - 49)",
    "CAR_ARRIVED.LICENSE_PLATE_EXAMPLE": "(Esim: 195-QUD)",
    "CAR_ARRIVED.VEHICLE_MODEL_EXAMPLE": "(Esim: Ford Bronco)",
    "CAR_ARRIVED.VEHICLE_COLOR_EXAMPLE": "(Esim: Sininen)",
    "REDIRECT_PICKUP.TO": "Kohteeseen",
    "REDIRECT_PICKUP.CONFIRM_TITLE": "Haluatko muuttaa noutopaikkaa?",
    "REDIRECT_PICKUP.SUCCESS_TITLE": "Noutopaikka vaihdettu onnistuneesti",
    "REDIRECT_PICKUP.FAILED_TITLE": "Noutopaikkaa ei voitu muuttaa",
    "REDIRECT_PICKUP.FAILED_DESCRIPTION": "Jotain meni pieleen",
    "REDIRECT_PICKUP.OK": "OK",
    "REDIRECT_PICKUP.KM": "km",
    "REDIRECT_PICKUP.SELECT_PICKUP_LOCATION": "Valitse noutopaikka",
    "REDIRECT_PICKUP.SET_AS_PICKUP_LOCATION": "Aseta noutopaikaksi",
    "REDIRECT_PICKUP.PICKUP_OPTIONS": "Noutoasetukset",
    "SOON": "Soon",
    "TRACKING.WANT_TO_CALL_YOUR_DRIVER": "Haluatko soittaa toimituskuljettajallesi?",
    "GLOBAL.CALL": "Soita",
    "GLOBAL.CANCEL": "Peruuta",
    "﻿PICKUP.SET_PICKUP_TIME": "Olen matkalla",
    "RATING.PROOF_OF_DELIVERY_MESSAGE": "Tilauksesi odottaa sinua aivan ovellasi!",
    "SCHEDULED.THANKS_FOR_USING": "Kiitos, että käytät {{merchant_name}}",
    "SCHEDULED.SHIPMENT_IN_TRANSIT": "Lähetyksesi {{external_id}} on matkalla",
    "SCHEDULED.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Tilauksesi on asetettu päivälle",
    "Submit": "Lähetä",
    "RATING.SELECT_STARS_BEFORE_SUBMIT": "Valitse tähdet ensin arvioidaksesi",
    "PICKUP.SHOW_ID": "Näytä ID",
    "TRACKING.ESTIMATED_TIME_ARRIVAL": "Arvioitu saapumisaika",
    "OPEN_MENU": "Avaa valikko",
    "CLOSE_MENU": "Sulje valikko",
    "MAP_AUTO_CENTER": "Auton kartta",
    "MAP_SETTINGS": "Kartta-asetukset",
    "ZOOM_OUT": "Loitonna",
    "ZOOM_IN": "Lähennä",
    "TRACKING.CALL_DRIVER": "Soita kuljettajalle",
    "TRACKING.MESSAGE_DRIVER": "Lähetä viesti kuljettajalle",
    "PICKUP.SELECT_TIME_TO_CONFIRM": "Vahvista noutoajan saapumisaika",
    "PICKUP.SET_OR_ARRIVE_DESCRIPTION": "Emme halua sinun odottavan.\nIlmoita, kun olet matkalla tai saapumassa:",
    "SCHEDULE.TIME_ZONE_TEXT": "Aikavyöhyke",
    "TRACKING.THANKS_MESSAGE_SUBTITLE": "Työskentelemme asian parissa!",
    "TRACKING.THANKS_MESSAGE_TEXT": "Keräämme tuotteesi ja tiimin jäsen tulee autollesi pian",
    "TRACKING.THANKS_MESSAGE_TITLE": "Kiitos tarkistuksesta",
    "TRACKING.CLICK_COLLECT_MESSAGE_TEXT": "Ole hyvä ja mene noutopisteeseen myymälässä, jossa tilauksesi on valmiina noudettavaksi",
    "CANCEL_ORDER": "Peru tilaus",
    "CANCELLATION_VALIDATION_TITLE": "Oletko varma, että haluat peruuttaa tämän tilauksen?",
    "CANCELLATION_VALIDATION_BACK": "Takaisin",
    "CANCELLATION_VALIDATION_YES": "Kyllä, kiitos",
    "CANCEL_SUCCESS": "Olemme peruuttaneet tilauksesi",
    "CANCEL_PAST_ALLOWED": "Tilauksen peruutus on vanhentunut",
    "CANCEL_ERROR": "Emme pystyneet peruuttamaan tilaustasi",
    "RATING.FREE_TEXT_COMMENT": "Kerro meille lisää",
    "RATING.ORDER_DELIVERED_GREEN": "Toimitimme tilauksesi ympäristöystävällisellä ajoneuvolla",
    "CX_ORDER_STATUS.CONFIRMED": "Tilaus on vahvistettu.",
    "CX_ORDER_STATUS.RECEIVED": "Tilaus on vastaanotettu.",
    "CX_ORDER_STATUS.FINDING_DRIVER": "Etsimme tilauksellesi kuljettajaa.",
    "CX_ORDER_STATUS.DRIVER_FOUND": "Olemme löytäneet tilauksellesi kuljettajan.",
    "CX_ORDER_STATUS.PICKING_UP": "Tilauksesi on keräilyssä.",
    "CX_ORDER_STATUS.WAY_TO_PICKUP": "Olemme matkalla noutamaan tilauksesi.",
    "CX_ORDER_STATUS.ON_PREVIOUS_DELIVERY": "Olemme toimittamassa edellistä tilausta.",
    "CX_ORDER_STATUS.WAY_TO_DROPOFF": "Tilauksesi on matkalla.",
    "CX_ORDER_STATUS.ARRIVED": "Tilauksesi on saapunut!",
    "TRACKING.DELIVERY_STATUS_TITLE": "Toimituksen tila",
    "CONFIGURATION.TAGS.SHOW_DELIVERY_STATUS": "Näytä toimituksen tila asiakkaille",
    "CONFIRM": "Vahvista",
    "FLOW_OPTIONS.TITLE": "Miten haluat noutaa tilauksesi?",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_LABEL": "Toimitettu autollesi merkitylle paikalle",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_TEXT": "Nouto autolta",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_LABEL": "Nouto myymälästä tai määritetystä paikasta",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_TEXT": "Click & collect",
    "RATING_STAR_ALT": "Valitse enintään 5 tähteä lähettääksesi arvioinnin",
    "RATING_STAR_ALT_ONE": "Valitse lähettääksesi",
    "RATING_STAR_ALT_TWO": "tähden arvio",
    "TRACKING.ARRIVING_IN_ARIA_LABEL": "Arvioitu saapumisaika on",
    "TRACKING.MAP_CONTAINER_ARIA_LABEL": "Kartta tilauksen seuraamiseen",
    "SCHEDULE.EXTERNAL_ID_INFO": "Tilausnumero: {{externalId}}",
    "SCHEDULE.TASK_NOTE_LABEL": "Kommentti",
    "SCHEDULE.CANCEL_NOTE_INPUT": "Tyhjennä",
    "DELIVERY_WAS_CANCELLED": "Toimitus peruttu",
    "QUESTIONNAIRE.SKIP": "Ohita",
    "QUESTIONNAIRE.SKIP_VALIDATION_HEADER": "Oletko varma, että haluat ohittaa?",
    "QUESTIONNAIRE.SKIP_VALIDATION_MESSAGE": "Joitakin kysymyksiä ei ole vastattu. Oletko varma, että haluat jatkaa niitä täyttämättä?",
    "QUESTIONNAIRE.BACK": "Takaisin",
    "QUESTIONNAIRE.SUBMIT_FAILED": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS": "",
    "QUESTIONNAIRE.NA_VALUE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_TITLE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_MESSAGE": ""
};
	